<template>
  <aside class="aside-menu">
    ASide
  </aside>
</template>

<script>
export default {
  name: "Aside"
};
</script>
